export const rabbitSignFieldTypes = Object.freeze({
  none: { key: 'none', value: 0, text: 'NONE', color: 'pink' },
  signature: { key: 'signature', value: 1, text: 'Signature', color: 'cyan' },
  initials: { key: 'initials', value: 2, text: 'Initials', color: 'green' },
  localDate: { key: 'localDate', value: 3, text: 'Local Date', color: 'purple' },
  textBox: { key: 'textBox', value: 4, text: 'Text Box', color: 'volcano' },
  checkBox: { key: 'checkBox', value: 5, text: 'Check Box', color: 'magenta' },
});